<template>
<div class="classReportBox">
    <div class="reportPage one_page">
        <div class="noPrintModel" style="height: 30px;"></div>
        <div class="firstTit">
            <h3>{{$route.query.trainName}}</h3>
        </div>
        <div class="twoTitinfo">
            <p>
                <span>时间：{{$route.query.time}}</span>
                <span>天气：{{tableFrom.weather}}</span>
                <span style="margin-left: 40px;">地点：{{tableFrom.address}}</span>
            </p>
        </div>
        <table>
            <template v-if="showModel.state">
            <tr>
                <td>授课老师</td>
                <td style="width: 70px;">{{tableFrom.teacherName}}</td>
                <td>应到人数</td>
                <td style="width: 40px;">{{tableFrom.ydCount}}</td>
                <td>病假</td>
                <td style="width: 40px;">{{tableFrom.bjCount}}</td>
                <td>迟到</td>
                <td style="width: 40px;">{{tableFrom.cdCount}}</td>
                <td>旷课</td>
                <td style="width: 120px;">{{tableFrom.kkCount}}</td>
            </tr>
            <tr>
                <td>课目</td>
                <td>{{tableFrom.name}}</td>
                <td>实到人数</td>
                <td>{{tableFrom.sdCount}}</td>
                <td>事假</td>
                <td>{{tableFrom.sjCount}}</td>
                <td>早退</td>
                <td>{{tableFrom.ztCount}}</td>
                <td>上下课时间</td>
                <td>{{tableFrom.skTime}}</td>
            </tr>
            <tr>
                <td>早上</td>
                <td style="text-align: left;" colspan="9">{{tableFrom.contents}}</td>
            </tr>
            </template>
            <template v-if="showModel.state2">
            <tr>
                <td>授课老师</td>
                <td>{{tableFrom.teacherName2}}</td>
                <td>应到人数</td>
                <td>{{tableFrom.ydCount2}}</td>
                <td>病假</td>
                <td>{{tableFrom.bjCount2}}</td>
                <td>迟到</td>
                <td>{{tableFrom.cdCount2}}</td>
                <td>旷课</td>
                <td>{{tableFrom.kkCount2}}</td>
            </tr>
            <tr>
                <td>课目</td>
                <td>{{tableFrom.name2}}</td>
                <td>实到人数</td>
                <td>{{tableFrom.sdCount2}}</td>
                <td>事假</td>
                <td>{{tableFrom.sjCount2}}</td>
                <td>早退</td>
                <td>{{tableFrom.ztCount2}}</td>
                <td>上下课时间</td>
                <td>{{tableFrom.skTime2}}</td>
            </tr>
            <tr>
                <td>上午</td>
                <td style="text-align: left;" colspan="9">{{tableFrom.contents2}}</td>
            </tr>
            </template>
            <template v-if="showModel.state3">
            <tr>
                <td>授课老师</td>
                <td>{{tableFrom.teacherName3}}</td>
                <td>应到人数</td>
                <td>{{tableFrom.ydCount3}}</td>
                <td>病假</td>
                <td>{{tableFrom.bjCount3}}</td>
                <td>迟到</td>
                <td>{{tableFrom.cdCount3}}</td>
                <td>旷课</td>
                <td>{{tableFrom.kkCount3}}</td>
            </tr>
            <tr>
                <td>课目</td>
                <td>{{tableFrom.name3}}</td>
                <td>实到人数</td>
                <td>{{tableFrom.sdCount3}}</td>
                <td>事假</td>
                <td>{{tableFrom.sjCount3}}</td>
                <td>早退</td>
                <td>{{tableFrom.ztCount3}}</td>
                <td>上下课时间</td>
                <td>{{tableFrom.skTime3}}</td>
            </tr>
            <tr>
                <td>下午</td>
                <td style="text-align: left;" colspan="9">{{tableFrom.contents3}}</td>
            </tr>
            </template>
            <template v-if="showModel.state4">
            <tr>
                <td>授课老师</td>
                <td>{{tableFrom.teacherName4}}</td>
                <td>应到人数</td>
                <td>{{tableFrom.ydCount4}}</td>
                <td>病假</td>
                <td>{{tableFrom.bjCount4}}</td>
                <td>迟到</td>
                <td>{{tableFrom.cdCount4}}</td>
                <td>旷课</td>
                <td>{{tableFrom.kkCount4}}</td>
            </tr>
            <tr>
                <td>课目</td>
                <td>{{tableFrom.name4}}</td>
                <td>实到人数</td>
                <td>{{tableFrom.sdCount4}}</td>
                <td>事假</td>
                <td>{{tableFrom.sjCount4}}</td>
                <td>早退</td>
                <td>{{tableFrom.ztCount4}}</td>
                <td>上下课时间</td>
                <td>{{tableFrom.skTime4}}</td>
            </tr>
            <tr>
                <td>晚自习</td>
                <td style="text-align: left;" colspan="9">{{tableFrom.contents4}}</td>
            </tr>
            </template>
            <tr>
                <td>情况反映</td>
                <td style="text-align: left;" colspan="9">{{tableFrom.summarys}}</td>
            </tr>
        </table>
    </div>
</div>
</template>

<script>
import * as echarts from 'echarts';
export default {
    name: 'classReport',
    props:['infoFrom','showModel'],
    data(){
        return {
            tableFrom:{}
        }
    },
    created(){
        this.tableFrom = this.infoFrom;
    },
    methods:{
        getFrom(val){
            this.tableFrom = val;
        },
    }
}
</script>

<style lang="less" scoped>
h1,h2,h3{
    padding: 0px;
    margin: 0px;
}
.classReportBox{
    position: relative;
    margin: 0;
    padding: 20px 0px;
    background-color: #f2f2f2;

    .reportPage{
        width: 190.5mm;
        min-height: 247mm;
        margin: auto;
        margin-bottom: 20px;
        box-shadow: 1px 1px 8px #e2e2e2;
        background-color: #fff;
        box-sizing: border-box;
        padding: 20px 45px;
    }

    .one_page{
        .firstTit{
            width: 100%;
            text-align: center;
            padding-bottom: 10px;
            h3{
                font-family: '宋体';
                font-size: 26px;
            }
        }
        .twoTitinfo{
            text-align: left;
            font-family: '宋体';
            font-size: 16px;
            padding-bottom: 8px;

            p{
                span + span{
                    margin-left: 10px;
                }
            }
        }
        table{
            width: 100%;
            border-collapse: collapse;
            font-family: '宋体';
            font-size: 16px;
            tr{
                text-align: center;
                th{
                    padding: 10px;
                }
                td{
                    padding: 10px 4px;
                    border: 1px solid #000;
                }
                .textCon{
                    text-align: left;
                }
            }
        }
    }
}

.floatKuang{
    position: absolute;
    top: 40px;
    right: 40px;
    width: 160px;
    height: 160px;
    background-color: #fff;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    box-shadow: -1px 1px 5px 0px #f2f2f2;

    p{
        font-size: 14px;
        box-sizing: border-box;
        color: #1870aa;
        padding: 10px 20px;
    }
}

.showPrintModel{
    display: none;
}

@media print {
    @page {
        size: 210mm 297mm; /* or size: 794px 1123px; */
    }
    *,body,#app{
        padding: 0px;
        margin: 0px;
    }
    .classReportBox{
        background-color: #fff;
    }
    .reportPage{
        box-shadow: none !important;
        margin-bottom: 0px !important;
        padding: 0px !important;
    }
    .noPrintModel{
        display: none;
    }
    .showPrintModel{
        display: block;
    }
}
</style>